<template>

    <!-- Configuration options -->
    <div id="configuration-options" tabindex="0">
        <div class="flex">
            <Configuration
                v-for="(configuration, c) of configurationControl.options"
                :key="c"
                :configuration="configuration"
                :expanded="yBarExpanded"
                :showOptions="configurationControl.show"
                :index="configuration.id"
                :showZoomControl="showZoomControl"
                @select="SelectConfiguration($event)"
            />
            <div class="btn configuration configuration-close flex-y-center" v-if="configurationControl.show" @click="CloseConfiguration()" @keypress.space.prevent="CloseConfiguration()" tabindex="0">
                <img src="@/assets/Images/CloseBlue.png" alt="Close" title="Close" width="30" height="30"/>
            </div>
        </div>
    </div>

    <div id="y-bar" :style="`width: ${width};`" tabindex="0">
        <div id="configurations">

            <!-- Main configuration control -->
            <div :class="['btn configuration flex-y-center y-bar-item', Classes().configurationsState]" @click="ToggleConfiguration()" @keypress.prevent="ToggleConfiguration()" @mouseenter="ConfigurationHover(true)" @mouseleave="ConfigurationHover()" tabindex="0">
                <Details
                    :iconSource="configurationControl.iconSource"
                    name="Configurations"
                    :index="0"
                    :yBarExpanded="yBarExpanded"
                />
            </div>
            <div :class="['configuration flex-y-center y-bar-item', Classes().yBarIconsState]" @click="$emit('search')" @keypress.space.prevent="$emit('search')" tabindex="0">
                <img :src="SearchIconSource().source" :alt="SearchIconSource().label" :title="SearchIconSource().label" width="30" height="30"/>
            </div>

        </div>
        <div id="month-labels" v-if="prioritySelected">
            <MonthLabel
                v-for="(month, m) in 12"
                :key="m"
                :month="MonthLabel(month)"
                :yBarExpanded="yBarExpanded"
            />
        </div>
    </div>
</template>

<script>
import Configuration from "@/components/Timeline/YBar/Configuration/Configuration.vue";
import MonthLabel from "@/components/Timeline/YBar/MonthLabel.vue";
import Details from "@/components/Timeline/YBar/Configuration/Details.vue";
import $ from "jquery";

export default {
    name: "TimelineYBar",
    props: {
        configurations: Object,
        prioritySelected: Boolean,
        enableConfigurations: Boolean
    },
    components: {
        Configuration,
        MonthLabel,
        Details
    },
    data: () => ({
        yBarExpanded: false,
        width: "70px",
        configurationControl: {
            show: false,
            options: {},
            iconSource: ""
        },
        showZoomControl: false
    }),
    methods: {
        GetMonthLabel: function(monthNumber) {
            switch(monthNumber) {
                case 1:
                    return {
                        long: "January",
                        short: "Jan"
                    };
                case 2:
                    return {
                        long: "February",
                        short: "Feb"
                    };
                case 3:
                    return {
                        long: "March",
                        short: "Mar"
                    };
                case 4:
                    return {
                        long: "April",
                        short: "Apr"
                    };
                case 5:
                    return {
                        long: "May",
                        short: "May"
                    };
                case 6:
                    return {
                        long: "June",
                        short: "Jun"
                    };
                case 7:
                    return {
                        long: "July",
                        short: "Jul"
                    };
                case 8:
                    return {
                        long: "August",
                        short: "Aug"
                    };
                case 9:
                    return {
                        long: "September",
                        short: "Sept"
                    };
                case 10:
                    return {
                        long: "October",
                        short: "Oct"
                    };
                case 11:
                    return {
                        long: "November",
                        short: "Nov"
                    };
                case 12:
                    return {
                        long: "December",
                        short: "Dec"
                    };
            }
        },
        MonthLabel: function(monthNumber) {
            const { short, long } = this.GetMonthLabel(monthNumber);
            return this.yBarExpanded ? long : short;
        },

        // Configurations
        SelectConfiguration: function(configuration) {
            const {
                detach,
                attach,
                yBarCollapsed,
                yBarExpanded
            } = this.configurations;
            switch(configuration.name) {
                case "Configurations":
                    this.configurationOptions.show = !this.configurationOptions.show;
                    break;
                case "Attach":
                    detach.show = true;
                    configuration.show = false;
                    break;
                case "Detach":
                    attach.show = true;
                    configuration.show = false;
                    break;
                case "Expand":
                    this.SetExpansion();
                    yBarCollapsed.show = true;
                    configuration.show = false;
                    break;
                case "Collapse":
                    this.SetExpansion();
                    yBarExpanded.show = true;
                    configuration.show = false;
                    break;
                case "Zoom":
                    this.showZoomControl = !this.showZoomControl;
                    break;
            }
            this.$emit("configure", configuration);
        },
        ConfigurationHover: function(over) {
            let source = over ? "IconConfigurationsActive.png" : "IconConfigurationsInactive.png";

            // If not hovering and configuration controls are showing, keep active icon
            if (!over && this.configurationControl.show) {
                source = "IconConfigurationsActive.png";
            }

            this.configurationControl.iconSource = require(`@/assets/Images/TimelineConfigurations/${source}`);
        },
        ToggleConfiguration: function() {
            this.configurationControl.show = !this.configurationControl.show;
            $("#configuration-options").focus();
        },
        CloseConfiguration: function() {
            this.configurationControl.show = false;
            this.ConfigurationHover(false);
        },
        SetExpansion: function() {
            this.yBarExpanded = !this.yBarExpanded;
            this.width = this.yBarExpanded ? "350px" : "70px";
        },

        Classes: function() {
            return {
                configurationsState: this.enableConfigurations ? "" : "disabled-fade",
                yBarIconsState: this.enableConfigurations ? "btn" : "disabled"
            };
        },
        SearchIconSource: function() {
            const source = this.enableConfigurations ? "IconSearchActive.png" : "IconSearchInactive.png";
            return {
                source: require(`@/assets/Images/${source}`),
                label: this.enableConfigurations ? "Search - Active" : "Search - Inactive"
            };
        }
    },
    beforeMount: function() {
        const configurationOptions = {};
        let c = -1;
        for (const configuration in this.configurations) {
            if (configuration !== "configurations") {
                c++;
                configurationOptions[configuration] = this.configurations[configuration];
                configurationOptions[configuration].id = c;
            }
        }
        this.configurationControl = {
            options: configurationOptions,
            iconSource: require("@/assets/Images/TimelineConfigurations/IconConfigurationsInactive.png")
        };
    },
    emits: [
        "configure",
        "search"
    ]
};
</script>